import React from 'react';
import PropTypes from 'prop-types';
import { KeyboardTimePicker } from '@material-ui/pickers';
import TextField from './TextField';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]),
  onChange: PropTypes.func.isRequired,
};

const defaultProps = {
  value: null,
};

function TimePicker(props) {
  const {
    label, value, onChange, ...others
  } = props;


  function handleDateChange(date) {
    onChange(date);
  }

  return (
    <KeyboardTimePicker
      // disableToolbar
      // autoOk
      okLabel="Seleccionar"
      cancelLabel=""
      format="hh:mm A"
      mask="__:__ _M"
      inputVariant="outlined"
      invalidDateMessage=""
      label={label}
      value={value}
      onChange={handleDateChange}
      TextFieldComponent={TextField}
      {...others}
    />
  );
}

TimePicker.propTypes = propTypes;

TimePicker.defaultProps = defaultProps;

export default TimePicker;
